module.exports = __webpack_public_path__ + "static/media/icon-booth-clothing.3b4b73f4.svg";